import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './Menu.module.css';

type MenuProps = {
    mainY: number;
    setAndKeepMainY: (newMainY: number, prevMainY: number) => void;
    scrollBack: () => void;
};

const Menu: React.FC<MenuProps> = ({ scrollBack }) => {
    const topRef = useRef<HTMLDivElement | null>(null);
    const { t } = useTranslation();

    const footerStyle: React.CSSProperties = {
        height: '150px',
        marginTop: '10px',
    };

    const hrStyle: React.CSSProperties = {
        borderTop: '1px solid #F1EFEC',
        background: 'transparent',
    };

    const linkStyle: React.CSSProperties = {
        textDecoration: 'none',
        color: '#fff', // Dit is wit zoals in het tweede bestand
    };

    const leftLinkStyle: React.CSSProperties = {
        float: 'left',
        marginLeft: '10px',
    };

    const middleLinkStyle: React.CSSProperties = {
        marginLeft: '20px',
    };

    const rightLinkStyle: React.CSSProperties = {
        float: 'right',
        marginRight: '20px',
    };

    const rightMostLinkStyle: React.CSSProperties = {
        float: 'right',
        marginRight: '50px',
    };

    return (
        <div className={styles.Menu}>
            <div className={styles.menucontainer}>
                <div ref={topRef} className={styles.header}>
                    <div className={styles.header_logo}
                        onClick={(e: any) => {
                            e.preventDefault();
                        }}>
                        <div>
                            <div className={styles.header_logo_svg}>
                                <img src="logo-common.png" alt="Logo" />
                            </div>
                        </div>
                    </div>
                    <div className={styles.topRightButton}>
                        <GenericIconButton
                            icon='light/times.svg'
                            hoverEnabled={true}
                            width='28px'
                            height='28px'
                            onClick={(e: any) => {
                                scrollBack();
                            }}
                        />
                    </div>
                </div>
                <div className={styles.menubody}>
  <footer className={styles.footer}>
    <div style={footerStyle}>
      {/* Afbeeldingen */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {/* Eerste afbeelding met link */}
        <a 
          href="https://www.provincedeliege.be/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ marginRight: "10px" }} // Ruimte tussen afbeeldingen
        >
          <img 
            src="https://commoncollections.be/images/footerProv.jpg" 
            alt="Province de Liège" 
            style={{ height: "100px" }} 
          />
        </a>

        {/* Tweede afbeelding met link */}
        <a 
          href="https://www.federation-wallonie-bruxelles.be/" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img 
            src="https://commoncollections.be/images/footerFed.jpg" 
            alt="Fédération Wallonie-Bruxelles" 
            style={{ height: "100px" }} 
          />
        </a>
      </div>

      {/* Tekst onder de afbeeldingen */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
          <p>
          Une initiative de la Province de Liège. 
          <br  />Contact : {" "}
            <a 
              href="mailto:commoncollections@provincedeliege.be" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "grey", textDecoration: "none" }}
            >
              commoncollections@provincedeliege.be
            </a> <br  />
            <a 
              href="https://www.provincedeliege.be/fr/cookies" 
              style={{ color: "grey", textDecoration: "none", marginRight: "10px" }}
            >
              Charte d'utilisation
            </a>
            |  
            <a 
              href="https://www.provincedeliege.be/fr/" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "grey", textDecoration: "none", marginLeft: "10px" }}
            >
              Politique de confidentialité
            </a>
          </p>
          <p>
          COMMON COLLECTIONS est un réseau constitué à l’initiative de la Province de Liège, rassemblant seize institutions culturelles de Wallonie, de statut public et associatif. 
          <br />Le projet a pour but de rassembler au sein d’un espace numérique commun – et par conséquent de rendre accessible au plus grand nombre – les collections patrimoniales conservées par les différents partenaires, dont une partie seulement est exposée.
          </p>
        </div>
    </div>
  </footer>
</div>

            </div>
        </div>
    );
};

export default Menu;
